import moment from 'moment'

import { Event, EventByDayType } from 'types'

export function display(seconds: number) {
  const d = Math.floor(seconds / (3600 * 24))
  const h = Math.floor((seconds % (3600 * 24)) / 3600)
  const m = Math.floor((seconds % 3600) / 60)
  const s = Math.floor(seconds % 60)
  const dDisplay = d > 0 ? d + 'd ' : ''
  const hDisplay = h > 0 ? h + 'h ' : ''
  const mDisplay = m > 0 ? m + 'm ' : ''
  const sDisplay = s > 0 ? s + 's ' : ''
  return dDisplay + hDisplay + mDisplay + sDisplay
}

export const mapByDay = (events: Event[] = []): EventByDayType => {
  const eventByDay: EventByDayType = {}

  //sort by time all events first
  events.sort((a, b) => {
    return new Date(b.time!).getTime() - new Date(a.time!).getTime()
  })

  for (const evt of events) {
    const day = moment(evt.time?.slice(0, -1)).format('MMMM D, YYYY')

    //add unique id to each event to avoid duplicates from backend
    evt.id = crypto.randomUUID()

    if (day in eventByDay) {
      eventByDay[day].push(evt)
    } else {
      eventByDay[day] = [evt]
    }
  }

  Object.values(eventByDay).forEach((el, ind) => {
    el.sort((a, b) => {
      return new Date(b.time!).getTime() - new Date(a.time!).getTime()
    })
  })

  return eventByDay
}
